import { render, staticRenderFns } from "./pageDialogs.vue?vue&type=template&id=8048a882&scoped=true&lang=pug&"
import script from "./pageDialogs.vue?vue&type=script&setup=true&lang=js&"
export * from "./pageDialogs.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./pageDialogs.vue?vue&type=style&index=0&id=8048a882&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8048a882",
  null
  
)

export default component.exports